import main from "../assets/main.jpg";
import ec_main from "../assets/ec-main.jpg";
// import logo_eComic from "../assets/01-main-eComic_4x.png";
import eComicSeries_alpha0 from "../assets/00-eComic-series_4x.png";
import main_pc01 from "../assets/00-main01-pc_4x.png";
import main_pc02 from "../assets/00-main02-pc_4x.png";
import main_sp01 from "../assets/00-main01-sp_4x.png";
import main_sp02 from "../assets/00-main02-sp_4x.png";
import logo_eComicSP from "../assets/00-eCSPlus-Ru-gy_4x.png";
import logo_eComicSP_K from "../assets/02-eCSPlus-bk_4x.png";
import logo_eComicSP_W from "../assets/02-eCSPlus-wh_4x.png";
import logo_eComicSR from "../assets/00-eCSR-Ru-gy_4x.png";
import logo_eComicSR_K from "../assets/03-eCSR-bk_4x.png";
import plus_pc from "../assets/eComicScreenPlus-00_2x.png";
import plus01 from "../assets/eComicScreenPlus-01_2x.png";
import plus02 from "../assets/eComicScreenPlus-02_2x.png";
import plus03 from "../assets/eComicScreenPlus-03_2x.png";
import plus04 from "../assets/eComicScreenPlus-04_2x.png";
import plus05 from "../assets/eComicScreenPlus-05_2x.png";
import sr_pc from "../assets/eComicSR-00_2x.png";
import sr01 from "../assets/eComicSR-01_2x.png";
import sr02 from "../assets/eComicSR-02_2x.png";
import sr03 from "../assets/eComicSR-03_2x.png";
import sr04 from "../assets/eComicSR-04_2x.png";
import sample01 from "../assets/01_oldsize_Line.jpg";
import sample02 from "../assets/02_newsize_Line.jpg";
import sample03 from "../assets/03_newsize_ecsPlus_Line.jpg";
import pagetop from "../assets/pageTop.png";
import tomowellogo from "../assets/logo.svg";

import compare_01 from "../assets/02_newsize.jpg";
import compare_02 from "../assets/03_newsize_ecsPlus.jpg";

export const mainImg = main;
export const eCMainImg = ec_main;

// export const logoEComic = logo_eComic;

export const eComicSeriesAlpha0 = eComicSeries_alpha0;

export const main01_pc = main_pc01;
export const main02_pc = main_pc02;
export const main01_mobile = main_sp01;
export const main02_mobile = main_sp02;

export const logoEComicSP = logo_eComicSP;
export const logoEComicSP_K = logo_eComicSP_K;
export const logoEComicSP_W = logo_eComicSP_W;
export const logoEComicSR = logo_eComicSR;
export const logoEComicSR_K = logo_eComicSR_K;

export const plusComic = plus_pc;
export const plus01img = plus01;
export const plus02img = plus02;
export const plus03img = plus03;
export const plus04img = plus04;
export const plus05img = plus05;

export const srComic = sr_pc;
export const sr01img = sr01;
export const sr02img = sr02;
export const sr03img = sr03;
export const sr04img = sr04;

export const sample01img = sample01;
export const sample02img = sample02;
export const sample03img = sample03;

export const pageTop = pagetop;

export const tomowelLogo = tomowellogo;

export const compare01 = compare_01;
export const compare02 = compare_02;